import React from 'react';
import { Control, Form, actions } from 'react-redux-form';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  baseTradeSecurityPath,
  enumSecurityOrderTypes,
  tradeSecurityPath,
} from './Schemas/baseRrf';
import Select, { SELECT_STYLE } from './Controls/Select';
import InputField from './Controls/Field';

import './styles.css';

const getFields = (disabled, onChange) => ([
  {
    model: '.type',
    RRFComp: Control,
    control: {
      component: Select,
      selectStyle: SELECT_STYLE.BLUE,
      disabled,
      onChange: () => { onChange(); },
    },
  },
]);

const UnconnectedTradeOrderType = ({
  disabled,
  resetTradeSecurityForm,
  securityId,
  tradeDir,
}) => {
  const fields = getFields(disabled, resetTradeSecurityForm);
  return (
    <Form model={`${baseTradeSecurityPath}.tradeOrderType`}>
      <Link to={`/security-trade/${securityId}/${tradeDir}/order-type-trade`} styleName="formLabelLink">Order Type</Link>
      <InputField
        key={fields[0].model}
        fieldProps={fields[0]}
      >
        {enumSecurityOrderTypes.map(([key, value]) => (
          <option key={key} value={key}>{value}</option>
        ))}
      </InputField>
    </Form>
  );
};

const mapDispatchToProps = dispatch => ({
  resetTradeSecurityForm: () => (dispatch(actions.reset(tradeSecurityPath))),
});

export default connect(null, mapDispatchToProps)(UnconnectedTradeOrderType);



// WEBPACK FOOTER //
// ./src/components/Forms/TradeOrderType.js